class ApplyCTA extends ViewBasic {
    constructor(options) {
        super(options);

    }

    init(){
        this.addEvents();
    }

    addEvents() {
        $(window).on('scroll', e => this.scrollHandler(e));
    }

    removeEvents() {
        $(window).off('scroll', e => this.scrollHandler(e));
    }

    scrollHandler() {
        //Variables
        this.$elOffsetTop = this.$el.offset().top;
        this.$spontaneousOffsetTop = $('.career-spontaneous').offset().top;

        if(this.$elOffsetTop >= this.$spontaneousOffsetTop){
            if(this.$el.hasClass('fadeIn')){
                this.$el.removeClass('fadeIn');
            }
            this.$el.addClass('fadeOut');
        }
        else{
            if(this.$el.hasClass('fadeOut')){
                this.$el.removeClass('fadeOut');
            }
            this.$el.addClass('fadeIn');
        }

    }

    handleBreakpoints(e, params) {

    }
}

